import CheckboxColumn from './CheckboxColumn';

export default CheckboxColumn;
